if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
        this.eventProcessing = false;
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        // Single change listener that only publishes events
        // DO NOT mutate DOM, DO NOT call updateSelectedSwatchValue or updateVariant
        // The varient.liquid system handles all UI updates
        this.addEventListener('change', (event) => {
          // Prevent re-entrancy and cascading updates
          if (this.eventProcessing) return;

          // ✅ CRITICAL: Ignore filter select changes (they're not variant selections)
          // Filter selects have class .vef-select or are inside .variant-modal-filters
          if (event.target.closest('.variant-modal-filters') || event.target.classList.contains('vef-select')) {
            return;
          }

          // Only handle radio inputs and selects (not other form elements)
          if (event.target.type !== 'radio' && event.target.tagName !== 'SELECT') return;

          this.eventProcessing = true;

          // Defer event publishing to allow varient.liquid to handle DOM first
          requestAnimationFrame(() => {
            const target = this.getInputForEventTarget(event.target);

            // Publish event ONLY if FoxTheme is available
            // This lets product-info.js update the product without breaking varient.liquid UI
            if (window.FoxTheme && window.FoxTheme.pubsub && window.FoxTheme.pubsub.PUB_SUB_EVENTS) {
              FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
                data: {
                  event,
                  target,
                  selectedOptionValues: this.selectedOptionValues,
                },
              });
            }

            this.eventProcessing = false;
          });
        });
      }

      updateStockLabel() {
        // Find the variant data element
        const variantScript = this.querySelector('script[data-selected-variant]');
        if (!variantScript) return;

        try {
          const variant = JSON.parse(variantScript.textContent);
          const qty = variant.inventory_quantity || 0;
          const isOutOfStock = qty <= 0;

          // Update all stock labels in this variant-selects component
          const stockDots = this.querySelectorAll('.variant-stock-dot');
          const stockTexts = this.querySelectorAll('.variant-stock-text');
          const stockLabels = this.querySelectorAll('.variant-stock-label');

          stockDots.forEach(dot => {
            if (isOutOfStock) {
              dot.style.background = '#ef4444';
            } else {
              dot.style.background = '#22c55e';
            }
          });

          stockTexts.forEach(text => {
            text.textContent = isOutOfStock ? 'Out of stock' : 'In stock online';
            if (isOutOfStock) {
              text.style.color = '#ef4444';
            } else {
              text.style.color = 'inherit';
            }
          });
        } catch (e) {
          console.error('Error updating stock label:', e);
        }
      }
    }
  );
}
